"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STABLE_INFLECTION_SUGGESTION_KIND_DATA = exports.StableInflectionSuggestion = exports.StableInflectionSuggester = void 0;
const object_1 = require("../../util/object");
const string_normalizer_1 = require("../../util/string-normalizer");
const stable_data_1 = require("../data/stable-data");
const parser_1 = require("../parser");
const suggestion_1 = require("../suggestion");
const suggester_1 = require("./suggester");
class StableInflectionSuggester extends suggester_1.Suggester {
    constructor(text, ignoreOptions) {
        super(text, ignoreOptions);
        this.candidates = [];
    }
    prepare() {
        this.prepareVerbalVerb();
        this.prepareVerbalNoun();
        this.prepareVerbalOthers();
        this.prepareNominalAdjective();
        this.prepareNominalNoun();
        this.prepareAdverbial();
        this.prepareParticle();
    }
    prepareVerbalVerb() {
        const normalizedText = this.normalizedText;
        for (const [tense, tenseData] of object_1.ObjectUtil.entries(stable_data_1.STABLE_DATA.tense)) {
            for (const [aspect, aspectData] of object_1.ObjectUtil.entries(stable_data_1.STABLE_DATA.aspect)) {
                for (const [transitivity, transitivityData] of object_1.ObjectUtil.entries(stable_data_1.STABLE_DATA.transitivity)) {
                    for (const [polarity, polarityData] of object_1.ObjectUtil.entries(stable_data_1.STABLE_DATA.polarity)) {
                        const suffix = tenseData.suffix + aspectData.suffix[transitivity];
                        const prefix = polarityData.prefix;
                        if (normalizedText.startsWith(prefix) && normalizedText.endsWith(suffix)) {
                            const regexp = new RegExp(`^${prefix}|${suffix}$`, "g");
                            const name = normalizedText.replace(regexp, "");
                            const descriptions = [
                                { kind: "category", type: "verb" },
                                { kind: "tense", type: tense },
                                { kind: "aspect", type: aspect },
                                { kind: "transitivity", type: transitivity },
                                { kind: "polarity", type: polarity }
                            ];
                            this.candidates.push(["verbal", "verbalInflection", descriptions, name]);
                        }
                    }
                }
            }
        }
    }
    prepareVerbalNoun() {
        const normalizedText = this.normalizedText;
        const prefix = stable_data_1.STABLE_DATA.polarity.negative.prefix;
        if (normalizedText.startsWith(prefix)) {
            const regexp = new RegExp(`^${prefix}`, "g");
            const name = normalizedText.replace(regexp, "");
            const descriptions = [
                { kind: "category", type: "noun" },
                { kind: "polarity", type: "negative" }
            ];
            this.candidates.push(["verbal", "verbalInflection", descriptions, name]);
        }
    }
    prepareVerbalOthers() {
        const normalizedText = this.normalizedText;
        for (const [category, categoryData] of object_1.ObjectUtil.entries(stable_data_1.STABLE_DATA.verbalInflectionCategory)) {
            for (const [polarity, polarityData] of object_1.ObjectUtil.entries(stable_data_1.STABLE_DATA.polarity)) {
                const categoryPrefix = categoryData.prefix;
                const polarityPrefix = polarityData.prefix;
                const prefix = categoryPrefix + polarityPrefix;
                if (normalizedText.startsWith(prefix)) {
                    const regexp = new RegExp(`^${prefix}`, "g");
                    const name = normalizedText.replace(regexp, "");
                    const descriptions = [
                        { kind: "category", type: category },
                        { kind: "polarity", type: polarity }
                    ];
                    this.candidates.push(["verbal", "verbalInflection", descriptions, name]);
                }
            }
        }
    }
    prepareNominalAdjective() {
        const normalizedText = this.normalizedText;
        for (const [polarity, polarityData] of object_1.ObjectUtil.entries(stable_data_1.STABLE_DATA.polarity)) {
            const categoryPrefix = stable_data_1.STABLE_DATA.nominalInflectionCategory.adjective.prefix;
            const polarityPrefix = polarityData.prefix;
            const prefix = categoryPrefix + polarityPrefix;
            if (normalizedText.startsWith(prefix)) {
                const regexp = new RegExp(`^${prefix}`, "g");
                const name = normalizedText.replace(regexp, "");
                const descriptions = [
                    { kind: "category", type: "adjective" },
                    { kind: "polarity", type: polarity }
                ];
                this.candidates.push(["nominal", "nominalInflection", descriptions, name]);
            }
        }
    }
    prepareNominalNoun() {
        const normalizedText = this.normalizedText;
        const prefix = stable_data_1.STABLE_DATA.polarity.negative.prefix;
        if (normalizedText.startsWith(prefix)) {
            const regexp = new RegExp(`^${prefix}`, "g");
            const name = normalizedText.replace(regexp, "");
            const descriptions = [
                { kind: "category", type: "noun" },
                { kind: "polarity", type: "negative" }
            ];
            this.candidates.push(["nominal", "nominalInflection", descriptions, name]);
        }
    }
    prepareAdverbial() {
        const normalizedText = this.normalizedText;
        for (const [polarity, polarityData] of object_1.ObjectUtil.entries(stable_data_1.STABLE_DATA.polarity)) {
            const categoryPrefix = stable_data_1.STABLE_DATA.adverbialInflectionCategory.adverb.prefix;
            const polarityPrefix = polarityData.prefix;
            const prefix = categoryPrefix + polarityPrefix;
            if (normalizedText.startsWith(prefix)) {
                const regexp = new RegExp(`^${prefix}`, "g");
                const name = normalizedText.replace(regexp, "");
                const descriptions = [
                    { kind: "category", type: "adverb" },
                    { kind: "polarity", type: polarity }
                ];
                this.candidates.push(["adverbial", "adverbialInflection", descriptions, name]);
            }
        }
    }
    prepareParticle() {
        const normalizedText = this.normalizedText;
        const prefix = stable_data_1.STABLE_DATA.particleInflectionType.nonverb.prefix;
        if (normalizedText.startsWith(prefix)) {
            const regexp = new RegExp(`^${prefix}`, "g");
            const name = normalizedText.replace(regexp, "");
            const descriptions = [
                { kind: "form", type: "nonverb" }
            ];
            this.candidates.push(["particle", "particleInflection", descriptions, name]);
        }
    }
    presuggest(dictionary) {
        return [];
    }
    suggest(word, dictionary) {
        const suggestions = [];
        const normalizedName = string_normalizer_1.StringNormalizer.normalize(word.name, this.ignoreOptions);
        for (const candidate of this.candidates) {
            const [sort, kind, descriptions, name] = candidate;
            const wordSort = parser_1.Parser.createKeep().lookupSort(word, "ja");
            const desiredSort = stable_data_1.STABLE_DATA.sort[sort].abbreviations["ja"];
            if (normalizedName === name && (wordSort === null || wordSort === void 0 ? void 0 : wordSort.startsWith(desiredSort))) {
                const suggestion = new StableInflectionSuggestion(kind, descriptions, word.name);
                suggestions.push(suggestion);
            }
        }
        return suggestions;
    }
}
exports.StableInflectionSuggester = StableInflectionSuggester;
class StableInflectionSuggestion extends suggestion_1.Suggestion {
    constructor(kind, descriptions, name) {
        super(kind, descriptions, [name]);
    }
    getKindName(language) {
        return object_1.ObjectUtil.get(exports.STABLE_INFLECTION_SUGGESTION_KIND_DATA[this.kind].names, language);
    }
    getDescriptionName(kind, type, language) {
        var _a, _b, _c, _d, _e, _f;
        if (kind === "category") {
            return object_1.ObjectUtil.get((_a = object_1.ObjectUtil.get(stable_data_1.STABLE_DATA.category, type)) === null || _a === void 0 ? void 0 : _a.names, language);
        }
        else if (kind === "polarity") {
            return object_1.ObjectUtil.get((_b = object_1.ObjectUtil.get(stable_data_1.STABLE_DATA.polarity, type)) === null || _b === void 0 ? void 0 : _b.names, language);
        }
        else if (kind === "tense") {
            return object_1.ObjectUtil.get((_c = object_1.ObjectUtil.get(stable_data_1.STABLE_DATA.tense, type)) === null || _c === void 0 ? void 0 : _c.names, language);
        }
        else if (kind === "aspect") {
            return object_1.ObjectUtil.get((_d = object_1.ObjectUtil.get(stable_data_1.STABLE_DATA.aspect, type)) === null || _d === void 0 ? void 0 : _d.names, language);
        }
        else if (kind === "transitivity") {
            return object_1.ObjectUtil.get((_e = object_1.ObjectUtil.get(stable_data_1.STABLE_DATA.transitivity, type)) === null || _e === void 0 ? void 0 : _e.names, language);
        }
        else if (kind === "form") {
            return object_1.ObjectUtil.get((_f = object_1.ObjectUtil.get(stable_data_1.STABLE_DATA.particleInflectionType, type)) === null || _f === void 0 ? void 0 : _f.names, language);
        }
        else {
            return undefined;
        }
    }
}
exports.StableInflectionSuggestion = StableInflectionSuggestion;
exports.STABLE_INFLECTION_SUGGESTION_KIND_DATA = {
    verbalInflection: { names: { ja: "動辞の語形変化", en: "Inflection of verbal" } },
    nominalInflection: { names: { ja: "名辞の語形変化", en: "Inflection of nominal" } },
    adverbialInflection: { names: { ja: "副辞の語形変化", en: "Inflection of adverbial" } },
    particleInflection: { names: { ja: "助接辞の語形変化", en: "Inflection of particle" } }
};
